<template>
    <div>
        <b-row>
            <b-col cols="12">
                <app-form-select-input
                    :options="itemTypes"
                    label="Tipo de herramienta"
                    v-model="itemSubType.itemTypeId"
                    :required="true"
                    :hasError="$v.itemSubType.itemTypeId.$error"
                    errorMessage="Debe seleccionar el tipo de herramienta"
                    @change="$v.itemSubType.itemTypeId.$touch()"
                    :disabled="!!itemType"
                />
            </b-col>
            <b-col cols="12">
                <app-form-text-input
                    label="Nombre"
                    v-model="itemSubType.name"
                    :required="true"
                    :hasError="$v.itemSubType.name.$error"
                    errorMessage="Debe escribir el nombre"
                    @input="$v.itemSubType.name.$touch()"
                />
            </b-col>
            <b-col cols="12">
                <app-form-textarea-input label="Descripción" v-model="itemSubType.description" />
            </b-col>
        </b-row>
    </div>
</template>
<script>
import itemsRepository from '../../../../repositories/items.repository.js'
import { required, numeric } from 'vuelidate/lib/validators'
export default {
    props: {
        mySubType: {
            default: null,
        },
        onSave: {
            type: Function,
        },
        itemType: {
            type: Object,
        },
    },

    data() {
        return {
            itemSubType: {
                itemTypeId: '',
                name: '',
                description: '',
            },
            itemTypes: [],
        }
    },

    validations: {
        itemSubType: {
            itemTypeId: { required },
            name: { required },
        },
    },

    watch: {
        mySubType(val) {
            this.fillForm()
        },
    },

    methods: {
        async loadItemsType() {
            const { data } = await repo.get('item-types')
            this.itemTypes = data
        },
        async save() {
            this.$v.$touch()
            if (this.$v.$invalid)
                return toastr.error(
                    'Debe diligenciar todos los campos correctamente'
                )

            const { data } = await repo.post('item-sub-types', this.itemSubType)

            if (data.status) {
                toastr.success('Subtipo creado satisfactoriamente')
                this.$emit('created', data.result)
            } else {
                toastr.error(data.msg)
            }
        },
        async updateItemSubType() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }
            const { data } = await repo.put(
                `item-sub-types/${this.mySubType.id}`,
                this.itemSubType
            )
            if (data.status) {
                toastr.success(data.msg)
                Object.keys(this.itemSubType).map(
                    (key) => (this.itemSubType[key] = '')
                )
                this.$emit('updated', data)
                this.$v.$reset()
            } else {
                toastr.error(data.msg)
            }
        },
        saveOrUpdate() {
            if (!!this.mySubType) {
                this.updateItemSubType()
            } else {
                this.save()
            }
        },
        fillForm() {
            if (Object.keys(this.mySubType).length !== 0) {
                this.itemSubType.name = this.mySubType.name
                this.itemSubType.description = this.mySubType.description
                this.itemSubType.itemTypeId = this.mySubType.item_type_id
            } else {
                this.cleanFields()
            }
        },
        cleanFields() {
            Object.keys(this.itemSubType).map(
                (key) => (this.itemSubType[key] = '')
            )
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },
    },

    created() {
        this.$bus.$on('item-sub-type-form.save', this.saveOrUpdate)
        this.$bus.$on('item-sub-type-form.clean', this.cleanFields)
        !this.itemType && this.loadItemsType()
    },
    mounted() {
        if (!!this.itemType) {
            this.itemTypes.push(this.itemType)
            this.itemSubType.itemTypeId = this.itemType.id
        }
    },
    beforeDestroy() {
        this.$bus.$off('item-sub-type-form.save')
    },
}
</script>
